module.exports = __webpack_public_path__ + "assets/2abc3004aac8bd485623b46fab674735.png";